/** Prefix of the per-user localStorage mirror written by the retired userUiSettings layer. */
const LEGACY_USER_UI_SETTINGS_PREFIX = "userUiSettings_";

/** Browser-local settings of the logbook check and audit pages, replaced by userState. */
const LEGACY_LOGBOOK_KEYS = [
  "logbookCheck_fromDate",
  "logbookCheck_toDate",
  "logbookCheck_distanceDecimals",
  "logbook-check-column-visibility",
  "logbookAudit_fromDate",
  "logbookAudit_toDate",
  "logbookAudit_distanceDecimals",
  "logbookAudit_tileLayer",
  "logbookAudit_includeArchived",
  "logbookAudit_mapWidth",
  "logbookAudit_summaryOpen",
  "logbookAudit_showUnbooked",
];

/**
 * Removes orphaned localStorage keys left over from the pre-userState era.
 * Called once on add-in load; safe to call multiple times.
 */
export function removeLegacyLocalStorageKeys(): void {
  try {
    // Legacy date-range keys from before the per-user settings record
    localStorage.removeItem("ffov_fromDate");
    localStorage.removeItem("ffov_toDate");
    localStorage.removeItem("fuelCell_fromDate");
    localStorage.removeItem("fuelCell_toDate");
    // Legacy selection keys from before the per-user settings record
    localStorage.removeItem("selectedPresetId");
    localStorage.removeItem("selectedViewId");
    // Legacy logbook column visibility, now stored in userState
    localStorage.removeItem("logbook-column-visibility");
    // Logbook check/audit settings, now stored in userState
    for (const key of LEGACY_LOGBOOK_KEYS) localStorage.removeItem(key);
    // Per-user mirror of the retired userUiSettings record. Collect first: removing while
    // iterating by index would shift the remaining keys.
    const mirrorKeys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(LEGACY_USER_UI_SETTINGS_PREFIX)) mirrorKeys.push(key);
    }
    for (const key of mirrorKeys) localStorage.removeItem(key);
  } catch {
    // Storage may be unavailable (private mode, disabled, quota); ignore.
  }
}
